<template>
  <center>
    <div class="card card-body agatrs-card-style">
      <div class="col-md-12">
        <Header pageTitle="Edit Profile " class="card-container"></Header>

        <form @submit.prevent="updateProfile">
          <div class="row">
            <div class="col-md-6">
              <legend>Edit Information</legend>

              <hr />
              <fieldset>
                <div class="edit_information_grid">
                  <div>
                    <base-input type="text" label="First Name" :disabled="isAllowEdit" placeholder="First Name"
                      v-model="user.firstName">
                    </base-input>
                  </div>
                  <div>
                    <base-input label="Middle Name" :disabled="isAllowEdit" v-model="user.middleName"
                      placeholder="Middle Name" addon-left-icon="tim-icons icon-single-02"></base-input>
                  </div>
                  <div>
                    <base-input type="text" label="Last Name" placeholder="Last Name" :disabled="isAllowEdit"
                      v-model="user.lastName" addon-left-icon="tim-icons icon-single-02">
                    </base-input>
                  </div>
                  <div>
                    <base-input label="Title" :error="getError('title')" :disabled="isAllowEdit" v-model="user.title"
                      name="title" type="text" placeholder="Title" addon-left-icon="tim-icons icon-badge"></base-input>
                  </div>
                  <div>
                    <base-input label="Phone Number" :error="getError('phoneNumber')" :disabled="isAllowEdit"
                      v-model="user.phoneNumber" name="phonenumber" type="text" placeholder="Phone number"
                      addon-left-icon="tim-icons icon-mobile"></base-input>
                  </div>
                  <div>
                    <base-input label="Email" disabled v-model="user.email" name="email" placeholder="Email"
                      addon-left-icon="tim-icons icon-email-85"></base-input>
                  </div>

                  <div>
                    <base-input disabled v-model="user.approvalStatusName" label="Status">
                    </base-input>
                  </div>
                  <div>
                    <base-input disabled v-model="this.user.approverNameLabel" label="Approver">
                    </base-input>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="row">
                  <div class="col-md-12">
                    <base-input :label="isPartner ? 'Partner Nation Manager' : 'Sponsor'" :error="getError('sponsor')">
                      <v-select class="style-chooser" v-model="user.sponsorId"
                        :disabled="isOUSD || (isSelf && isSponsor)" :aria-label="`${selectedSponserUserLabel}`"
                        v-b-popover.hover.top="selectedSponserUserLabel" name="sponsor" :reduce="(user) => user.id"
                        label="nameLabel" :options="sponsorUsers" :selectable="selectable" placeholder="Select one">
                        <template v-slot:option="option">
                          {{ option.nameLabel }}
                        </template>
                      </v-select>
                    </base-input>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="row">
                  <div class="col-md-12">
                    <base-input v-if="!isPartner" :disabled="isOUSD || isSelf" label="Organization"
                      :error="getError('organization')">
                      <treeselect :disabled="isOUSD || isSelf" aria-label="Select organization from the dropdown list"
                        v-model="user.organizationId" class="select-primary" name="organization"
                        :options="jointStaffOrganizations" />
                    </base-input>
                    <base-input v-if="isPartner" label="Country" disabled="true" v-model="userCountries">
                    </base-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <base-input label="Role(s)" :error="getError('roles')">
                      <v-select class="style-chooser" v-model="user.roles" name="roles" multiple
                        :disabled="isOUSD || !isAllowEdit || isPartner || (isSelf && isSponsor)"
                        :reduce="(role) => role.name" label="name" :options="roles" placeholder="Select one">
                        <template #option="option">
                          <div :class="{ 'isNotApproved': !option.isActive }">
                            {{ option.name }}
                          </div>
                        </template>
                      </v-select>
                    </base-input>
                  </div>
                </div>

                <div v-if="isSponsor || isPNManager" class="row">
                  <div class="col-md-12">
                    <base-input v-if="isAllowEdit || isDisabled" label="Approval">
                      <el-tooltip placement="top">
                        <template #content>
                          {{ lockUnlockInfo }}
                        </template>
                        <lock-button v-on:reloadUnlockLockInfo="reloadUnlockLockInfo"
                          v-bind:organizationId="user.organizationId" :id="$route.params.id"></lock-button>
                      </el-tooltip>
                      <approval-modal v-bind:organizationId="user.organizationId" :id="$route.params.id"
                        :user="user"></approval-modal>
                    </base-input>
                  </div>
                </div>
              </fieldset>
              <base-button v-if="isApprovedUser && !isOUSD && (isSponsor || isPNManager) && !isSuperAdmin"
                native-type="submit" size="md" :class="'btn_extra_small btn-primary'"" :disabled="!hasPermission">
                Update Information
              </base-button>
              <base-button v-if="isApprovedUser && isSuperAdmin" native-type="submit" size="md"
                :class="'btn_extra_small btn-primary'">
                Update Information
              </base-button>
              <router-link to="/admin/users" class="btn btn-secondary"><span> Back </span></router-link>

              <div class="row">
                <div class="col-md-12 italics">
                  <label for="LastLoginDate">{{ lastLoggedInInfo }} </label>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 italics">
                  <label for="CreateDate">{{ createdDate }} </label>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 italics">
                  <label for="EmailConfirmation">{{ confirmedEmailInfo }}
                  </label>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 italics">
                  <label for="LastUpdatedBy">{{ lastUpdatedByInfo }} </label>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <fieldset>
                <legend>Documentation</legend>
                <user-upload v-if="(!isOUSD && isAllowEdit) || isDisabled && loggedInisOUSD()"
                  :email="user.email" :type="'admin'"></user-upload>
              </fieldset>
              <hr />


              <fieldset>

                <legend v-if="!isOUSD && loggedInisOUSD()">Other Settings</legend>
                <base-button v-if="(!isOUSD && isAllowEdit) || isDisabled && loggedInisOUSD()" type="dark"
                  class="btn-fill" @click="resendEmailConfirmation()" :disabled="buttonDisabled">
                  Resend Email Confirmation Link
                </base-button>

                <el-tooltip v-if="user.isCacRegistered" :visible="visible" class="display-inline" effect="light"
                  placement="top" content="CAC registered">
                  <!-- <div  onmouseover="visible= true" class="ml-2">
                    </div> -->
                  <base-button class="btn btn-default btn-md btn-secondary" :disabled="user.isCacRegistered"><span><i
                        class="tim-icons icon-badge"></i> CAC Registered</span></base-button>
                </el-tooltip>
              </fieldset>
              <hr v-if="isVisible" />

              <fieldset v-if="isVisible">
                <legend>Partner Nations Managed</legend>
                <el-card disabled class="box-card" shadow="always">
                  <div style="text-align: left" v-for="i in countryIds" :key="i.id" class="text item"
                    :class="i.isPartnerNationApproval ? 'isApproved' : 'isNotApproved'">
                    <div class="text">
                      <i class="tim-icons icon-world"></i> {{ i.name }}
                      <span v-if="!i.isPartnerNationApproval">
                        (Not Active)
                      </span>
                    </div>
                  </div>
                </el-card>
              </fieldset>

              <fieldset>
                <div class="content_padding_top_small date">
                 
                  <label for="signatureDate">Account Expiration</label>
                  <el-tooltip effect="dark" placement="top-start"
                    :content="isPartner ? 'Contact Partner Nation Manager to update expiration date' : 'Contact Sponsor to update expiration date'">
                    <el-date-picker :disabled="this.isSelf || !loggedInisOUSD()|| ! permissions[0].hasPermission" id="signatureDate" type="date"
                      v-model="user.expirationDate" format="dd-MMMM-yyyy" data-vv-as="Account Expiration"
                      name="dateSigned" :editable="false" :picker-options="endDatePickerOptions" :clearable="false">
                    </el-date-picker>
                  </el-tooltip>
                </div>
                <span>Please select date in range of 1 year</span>
              </fieldset>
            </div>
          </div>
        </form>
      </div>
    </div>
  </center>
</template>

<script>
import UserUpload from "@/components/App/account/documents/UserDocuments";
import LockButton from "@/components/App/account/LockButton";
import ApprovalModal from "@/components/App/account/Approval";
import { mapGetters, mapActions } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import Header from "@/components/App/Header.vue";
import swal from "sweetalert2";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Util from "@/util/util";
import axios from "@/axios";
import {
  Table,
  TableColumn,
  Upload,
  Button,
  Tag,
  Select,
  Option,
  Alert,
  Form,
  FormItem,
  CheckboxGroup,
  Checkbox,
  Divider,
  Tooltip,
  Card,
} from "element-ui";
import moment from "moment";
import { organizationNormalizer } from "@/util/formUtils"

export default {
  name: "AdminUserProfile",
  components: {
    ApprovalModal,
    LockButton,
    UserUpload,
    [Card.name]: Card,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Upload.name]: Upload,
    [Button.name]: Button,
    [Alert.name]: Alert,
    [Tag.name]: Tag,
    [Form.name]: Form,
    [Tooltip.name]: Tooltip,
    [FormItem.name]: FormItem,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Divider.name]: Divider,
    [Select.name]: Select,
    [Option.name]: Option,
    Treeselect,
    Header,
  },
  data() {
    return {
      id: this.$route.params.id,
      existingApprovedById: null,
      buttonDisabled: false,
      visible: false,
      originalSponosrId: null,
      userLockSponsor: null,
      userUnlockSponosr: null,
      lockUnlockInfo: "This user hasn't been locked yet.",
      endDatePickerOptions: {
        disabledDate: this.disabledEndDate,
      },
      countryIds: [],
      isDisabled: false,
      isVisible: false,
      isTier1: false
    };
  },
  watch: {
    user: {
      deep: true,
      handler(newUserData, oldUserData) {
        if (newUserData.approvalStatusId !== 1) {
          this.existingApprovedById = oldUserData.approverId;
        }
      },
    },
    getUserLockSponsor(n, p) {
      if (n != null && n != undefined && n != '') {
        // if unlocked sponosr email is not null and id is not == the user id
        // if id == user id, it is because user unlock it by password reset only if they are
        // locked out by EF not by admin
        if (n.email !== null) {
          if (n.id !== this.$route.params.id)
            this.lockUnlockInfo = `Account Locked by ${n.firstName} ${n.lastName} ${n.email} ${Util.formatDateWithLocalTimezone(n.lockUnlockDate)}`;

          // user id == unlock user id, it is user it self  
          else
            this.lockUnlockInfo = `Account locked. Requires password reset.`;
        }
      }
    },
    getUserUnLockSponsor(n, p) {
      if (n != null && n != undefined && n != '') {
        if (n.email !== null) {
          if (n.id !== this.$route.params.id)
            this.lockUnlockInfo = `Account unlocked by ${n.firstName} ${n.lastName} ${n.email} ${Util.formatDateWithLocalTimezone(n.lockUnlockDate)}`;
          else
            this.lockUnlockInfo = `Account unlocked user password reset.`;
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      jointStaffOrganizations: "organization/jointStaffOrganizations",
      roles: "role/roles",
      approvalStatuses: "approvalStatus/approvalStatuses",
      permissions: "permissions/permissions",
      sponsorUsers: "users/sponsorUsers",
      user: "users/user",
      getMyself: "authentication/getUser",
      isSponsor: "authentication/isSponsor",
      authenticatedUser: "users/authenticatedUser",
      isOUSD: "authentication/isOUSD",
      isPartnerAccount: "authentication/isPartnerAccount",
      isSuperAdmin: "authentication/isSuperAdmin",
      getUserLockSponsor: "users/getUserLockSponsor",
      getUserUnLockSponsor: "users/getUserUnLockSponsor",
      isPNManager: "authentication/isPNManager",
      allCountries: "countries/allCountries",
    }),
    // disable for now
    hasPermission() {
      const key = `applicationusers:update`;
      return this.permissions.some(p => p.key.toLowerCase() === key);
    },
    isPartner() {
      return this.user && this.user.roleString == Util.PARTNER_NATION;
    },
  
    isSelf() {
      if (this.user != null) {
        return this.user.id === this.getMyself.id;
      }
      return false;
    },
    userCountries() {
      var str = '';
      if (this.user.countriesToManage) {
        if (this.user.countriesToManage.length > 0)
          str = this.user.countriesToManage[0].name;
        return str;
      }
    },
    approver() {
      var approver = this.sponsorUsers.filter(d => d.id == this.user.sponsorId);
      if (approver.length > 0)
        return approver[0].approverNameLabel;
      else
        return '';
    },
    isLocked() {
      return this.user.approvalStatusName == "LOCKED" ? true : false;
    },
    isApproved() {
      return this.user.approvalStatusName == "APPROVED" ? true : false;
    },
    isPartner() {
      return this.user && this.user.roleString == Util.PARTNER_NATION;
    },
    isApprovedUser() {
      return this.user.approvalStatusId == Util.APPROVED ? true : false;
    },
    async isPartnerRoleAssigned() {
      let userRoles = await this.user.roles
      if (userRoles) {
        return userRoles.includes(Util.PARTNER_NATION);
      }
    },

    isAllowEdit() {
      let roles = this.user.roles
      if (roles) {
        if (roles.includes("PartnerNation") && this.isPNManager) {
          let pnManagerCountryIds = this.getMyself.countries;
          let pnUserCountryId = this.user.countriesToManage[0].countryId || 0;
          let isIn = pnManagerCountryIds.indexOf(pnUserCountryId);
          if (isIn == -1) {
            return false;
          }
          return true;
        }
        else
          if (!roles.includes("PartnerNation") && (this.isSponsor || this.isSuperAdmin)) {
            //'not pn user but a sponsor or admin')
            return true;
          }
          else if (roles.includes("PartnerNation") && (!this.isSuperAdmin || this.isPNManager)) {
            return true
          } else {
            return true
          }

      } else {
        return false;
      }
    },
    lastLoggedInInfo() {
      return Util.isNullOrEmpty(this.user.lastLoginDate)
        ? `We do not have record of the last time ${this.user.firstName} logged in.`
        : `${this.user.firstName
        } last logged in on: ${Util.formatDateWithLocalTimezone(
          this.user.lastLoginDate
        )}`;
    },
    confirmedEmailInfo() {
      return this.user.emailConfirmed
        ? `${this.user.firstName}'s email IS confirmed.`
        : `${this.user.firstName}'s email is NOT confirmed.`;
    },
    lastUpdatedByInfo() {
      if (this.user.updatedBy) {
        const str = this.user.updatedBy;
        // Extract the name part
        const namePart = str.substring(0, str.indexOf('--'));
        // Extract the email part
        const emailPart = str.substring(str.indexOf('--') + 3, str.lastIndexOf('--') - 1);
        // Extract the date and time part
        const dateTimePart = str.substring(str.lastIndexOf('--') + 3);
        const formattedDate = Util.formatDateWithLocalTimezone(dateTimePart)
        return Util.isNullOrEmpty(this.user.updatedById) ?
          `We do not have record of last updated by for the user` :
          `Profile last updated by ${namePart}--${emailPart}--${formattedDate}`
      }
    },
    createdDate() {
      return Util.isNullOrEmpty(this.user.createDate) ?
        `We do not have record of Create date for the user` :
        `${this.user.firstName} registered on: ${Util.formatDateWithLocalTimezone(this.user.createDate)}`
    },
    selectedSponserUserLabel() {
      let selectedUser;
      if (this.user.sponsorId) {
        selectedUser = this.sponsorUsers.find(
          (user) => user.id === this.user.sponsorId
        );
      }
      return selectedUser ? selectedUser.nameLabel : "No user selected";
    },
  },
  async mounted() {
    this.$loaderApp.addRequest();
    await this.getRoles(this.$route.params.id);
    await this.getApprovalStatuses();
    await this.getSponsorUsers(true);
    await this.getUserByEmail();
    await this.getUser(this.$route.params.id);
    this.originalSponosrId = this.user['sponsorId'];
    await this.validateOrganization(this.user.organizationId);
    await this.loadUserUnLockSponsor(this.$route.params.id);
    await this.loadUserLockSponsor(this.$route.params.id);
    await this.getAllCountries()
    await this.getSelectedCountries();
    //await this.partnerNationCondition(await this.getMyself.id);
    await this.partnerNationCondition();
    await this.checkRoles('PartnerNationManager')
    await this.checkTier1()

    //this permission is only for the button to do the entire page we need to add attributes
    // which isnt happening on this iteration
    // disabling for now
 const val =  await this.checkPermission({resource:'applicationUsers', action:'update',  data: { Id: this.$route.params.id }});
    await this.agreementInformationCountryChanged();
    await this.getJointStaffOrganizations();
    this.$loaderApp.completeRequest();
  },
  methods: {
    ...mapActions({
      getJointStaffOrganizations: "organization/getJointStaffOrganizations",
      getRoles: "role/getUserRoles",
      // disabling for now
      checkPermission: "permissions/checkPermission",
      getApprovalStatuses: "approvalStatus/getApprovalStatuses",
      getSponsorUsers: "users/getSponsorUsers",
      updateUser: "users/updateUserAdmin",
      getUser: "users/getUser",
      getUserByEmail: "authentication/getUserByEmail",
      loadUserUnLockSponsor: "users/loadUserUnLockSponsor",
      loadUserLockSponsor: "users/loadUserLockSponsor",
      getAllCountries: "countries/getAllCountries",
      agreementInformationCountryChanged:
        "agreementInformation/agreementInformationCountryChanged",
    }),
    organizationNormalizer(node) {
      return organizationNormalizer(node, "organizationId", "name", "children");
    },
    async reloadUnlockLockInfo() {
      await this.loadUserUnLockSponsor(this.$route.params.id);
      await this.loadUserLockSponsor(this.$route.params.id);
    },
    loggedInisOUSD() {
      if (this.user.roles) {
        if (!this.getMyself.roles.includes('Ousd')) {
          return true;
        }
      }

      return false
    },
    async checkTier1() {
      this.isTier1 = await this.user.roles.includes('Tier1');
      return true;
    },
    async checkRoles(role) {

      let userRoles = await this.user.roles
      if (userRoles) {
        if (userRoles.includes(role)) {
          this.isVisible = true
          return false
        } else {
          this.isVisible = false
          return true
        }
      }
    },
    /*async getLoggedInCountries(id) {
        const loggedInUser = await axios.get("/api/applicationusers/id/" + id, { config: { showToast: false } });
        const loggedInUserCountries = loggedInUser.data.countriesToManage;
        return loggedInUserCountries
      },*/
    async getLoggedInCountries(id) {
      // guard against null or undefined calls
      if (!id) {
        return []
      }
      const { data } = await axios.get(
        `/api/applicationusers/id/${id}`,
        { config: { showToast: false } }
      )
      return data.countriesToManage || []
    },
    async partnerNationCondition(id) {
      // Use teh getter directly here, it's synchronous
      const loggedInUserId = this.getMyself.id
      //let loggedInUserCountries = await this.getLoggedInCountries(id);
      let loggedInUserCountries = await this.getLoggedInCountries(loggedInUserId);
      let userCountries = await this.user.countriesToManage
      let roles = await this.user.roles
      if (roles && roles.includes('PartnerNation') && this.isPNManager) {
        if (loggedInUserCountries && userCountries) {
          let profileCountryIds = userCountries.map((e) => e.countryId
          )
          let loggedInCountryIds = loggedInUserCountries.map((e) =>
            e.countryId
          )
          const intersection = profileCountryIds.filter(element => loggedInCountryIds.includes(element));
          if (intersection.length > 0) {
            this.isDisabled = false
            return false
          } else {
            this.isDisabled = true
            return true
          }
        } else {
          this.isDisabled = false
          return false
        }
      } else if (this.isSponsor) {
        if (this.user.sponsorId === this.getMyself.id) {
          this.isDisabled = false
          return false
        }
        else {
          this.isDisabled = true
          return true
        }

      } else {
        this.isDisabled = false
        return false
      }
    },

    disabledEndDate(time) {
      let disabled = false;
      let userRoles = this.user.roles;

      const selectedTime = new moment(time.getTime());
      let maxEndDate = null;
      // today's date
      const minstartDate = new moment(moment());
      if (userRoles) {
        maxEndDate = new moment(minstartDate).add(
          1,
          "year"
        );
      }

      // not less then today
      if (selectedTime < minstartDate) {
        disabled = true;
      }
      // not greater than a year from today
      if (selectedTime > maxEndDate) {
        disabled = true;

      }
      return disabled;
    },

    selectable(option) {
      // if this use is an admin, all options are selectable
      // except admin-self and the current editing user-self
      if (this.isSuperAdmin) {
        return option.id !== this.getMyself.id && option.id !== this.user.id;
      }
      // can only select/assign yourself to the user that you want to modify
      return option.id === this.getMyself.id;
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validateOrganization(organizationId) {
      let ctx = this;
      let found = ctx.jointStaffOrganizations.find(
        (o) => o.organizationId === organizationId || 48
      );

      return (found && found.organizationId) || 48;
    },
    async updateProfile(id) {
      const ctx = this;
      const isTier1 = this.isTier1;
      try {
        ctx
          .updateUser({ isSuperAdmin: false, isTier1 },)
          .then(async (res) => {
            if (res.status != false) {
              await ctx.getUser(this.id);
              new swal({
                title: "Successfully Saved",
                text: `User information updated successfully!`,
                icon: "success",
                confirmButtonColor: "#10b45a",
              });
            } else {
              await ctx.getUser(this.id);

              new swal({
                title: "Error!",
                text: `${res.res}`,
                icon: "error",
                confirmButtonColor: "#10b45a",
              });
            }
          })
      } catch (error) {
        new swal({
          title: "Error!",
          text: `${error}`,
          icon: "error",
          confirmButtonColor: "#10b45a",
        });
      }
    },
    resendEmailConfirmation() {
      this.buttonDisabled = true;
      const id = this.$route.params.id;
      const params = {
        id,
      };
      axios
        .get("api/authentication/resendconfirmemail", {
          params,
        })
        .then((response) => {
          new swal({
            title: "Success!",
            text: "Email Resent successfully",
            icon: "success",
            confirmButtonColor: "#10b45a",
          });
          this.buttonDisabled = false;
        })
        .catch((err) => {
          new swal({
            title: "Error!",
            text: "Email Resend Failed!",
            icon: "error",
            confirmButtonColor: "#10b45a",
          });
          this.buttonDisabled = false;
        });
    },
    getSelectedCountries() {
      if (this.user.countriesToManage) {
        var countries = this.user.countriesToManage;
        let temp = countries.map(a => {
          var ret = {
            id: a.countryId,
            name: a.name,
            isPartnerNationApproval: (a.isPartnerNationApproval) ? true : false
          };
          return ret;
        });

        var result = [];
        var approved = temp.filter(c => c.isPartnerNationApproval == true);
        var notApproved = temp.filter(c => !c.isPartnerNationApproval);
        result.push(...approved, ...notApproved);
        this.countryIds = result;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.edit_information_grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
}

.date {
  width: 50%;
}

@media only screen and (max-width: 1200px) {
  .edit_information_grid {
    grid-template-columns: 1fr;
  }
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.text {
  font-size: 12px !important;
  padding-top: 3px;
}

// .item {
//   margin-bottom: 18px;
// }

.isApproved {
  color: #048000;

  .tim-icons {
    color: green;
  }
}

.isNotApproved {
  color: grey;
}


.box-card {
  width: 280px;
  height: 150px;
  overflow: auto;
}
</style>
